import React from "react";

export default class PublicErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[PublicErrorBoundary]", error, info);
    this.setState({ info });
    // Enviar al backend para poder diagnosticar en producción
    try {
      const payload = {
        message: String(error?.message || error),
        stack: String(error?.stack || ""),
        component_stack: String(info?.componentStack || ""),
        path: typeof window !== "undefined" ? window.location.pathname : "",
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
      };
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/public/log-error`;
      if (typeof fetch === "function") {
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
          keepalive: true,
        }).catch(() => {});
      }
    } catch (_) { /* silent */ }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "40px 20px", fontFamily: "system-ui, sans-serif", textAlign: "center" }}>
          <h1 style={{ fontSize: 22, fontWeight: 900, marginBottom: 12 }}>
            Estamos ajustando la tienda
          </h1>
          <p style={{ color: "#555", marginBottom: 20 }}>
            Ocurrió un pequeño inconveniente cargando esta página. Puedes contactarnos directamente por WhatsApp:
          </p>
          <a
            href="https://wa.me/50243036012"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-block",
              background: "#25D366",
              color: "#fff",
              padding: "12px 22px",
              fontWeight: 700,
              textDecoration: "none",
              borderRadius: 8,
            }}
          >
            Escribir por WhatsApp
          </a>
          <div style={{ marginTop: 30 }}>
            <button
              onClick={() => { try { window.location.reload(); } catch (_) {} }}
              style={{
                background: "#000",
                color: "#FFD100",
                padding: "10px 18px",
                border: 0,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Reintentar
            </button>
          </div>
          {process.env.NODE_ENV !== "production" && (
            <pre style={{ marginTop: 20, textAlign: "left", background: "#f5f5f5", padding: 12, fontSize: 11, overflow: "auto" }}>
              {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
